// @flow
import dinero from 'dinero.js';

/* eslint import/prefer-default-export:0 */
export const getRawPriceWithPrecision = (value: number, precision: number = 2) => dinero({
  amount: parseInt(value, 10),
  precision,
}).toUnit();
